var initializeTogglePanel = function () {
	var panels = document.querySelectorAll('[data-panel]');
	var breakpointMedium = 768;
	var stayOpenValues = ['StayOpen', 'Tree', 'Lightbox'];
	// only respond to changes in viewport width, not height
	// start at 0 so setPanelVisibility function always runs the first time
	var lastViewportWidth = 0;

	// function to handle clicks on a button or anchor that toggles a panel's visibility
	var togglePanel = function (toggler) {
		// ignore Tabs, which also have aria-controls
		if (toggler.getAttribute('role') === 'tab') {
			return;
		}
		// make sure toggler is the element with aria-controls
		if (!toggler.hasAttribute('aria-controls')) {
			toggler = toggler.closest('[aria-controls]');
		}
		var id = toggler.getAttribute('aria-controls');
		var panel = document.getElementById(id);

		if (panel && panel.hasAttribute('data-panel')) {
			// hide or show the panel
			var show = panel.getAttribute('aria-hidden') !== 'false';

			if (show) {
				// show the panel
				panel.setAttribute('aria-hidden', false);

				// focus on element in panel if selector is specified
				var focusOn = panel.getAttribute('data-focus-on');
				if (focusOn) {
					var elementToFocusOn = panel.querySelector(focusOn);
					if (elementToFocusOn) {
						elementToFocusOn.focus();
					}
				}

				// if modal, send event for show or hide
				var isModal = panel.getAttribute('data-panel');
				if (isModal === 'Modal') {
					var event = new CustomEvent('modal:show', { detail: panel });
					document.dispatchEvent(event);
				}

				// set state of toggler icon
				if (toggler.className.indexOf('Button--toggler') !== -1) {
					toggler.setAttribute('aria-expanded', true);
				}

				// close other open panels if appropriate
				Array.prototype.forEach.call(panels, function (otherPanel) {
					// there are a few ways to label panels to make them stay open
					// for backwards compatibility, let's handle them all
					var panelAttribute = otherPanel.getAttribute('data-panel');
					var stayOpen = otherPanel.getAttribute('data-panel-stayopen');
					// is it visible?
					if (otherPanel.getAttribute('aria-hidden') !== 'true') {
						// is it closeable?
						if (!stayOpen && stayOpenValues.indexOf(panelAttribute) === -1) {
							// is it not itself? does it not contain the one we're showing?
							if (otherPanel !== panel && !otherPanel.contains(panel)) {
								// should it remain open based on breakpoint?
								switch (panelAttribute) {
									case 'hiddenForSmall':
										if (window.innerWidth < breakpointMedium) {
											otherPanel.setAttribute('aria-hidden', true);
										}
										break;
									case 'hiddenForMedium':
										if (window.innerWidth >= breakpointMedium) {
											otherPanel.setAttribute('aria-hidden', true);
										}
										break;
									default:
										otherPanel.setAttribute('aria-hidden', true);
										break;
								}
							}
						}
					}
				});
			} else {
				// hide the panel
				panel.setAttribute('aria-hidden', 'true');

				// if modal, send event for show or hide
				var isModal = panel.getAttribute('data-panel');
				if (isModal === 'Modal') {
					var event = new CustomEvent('modal:hide', { detail: panel });
					document.dispatchEvent(event);
				}

				// set state of toggler icon
				if (toggler.className.indexOf('Button--toggler') !== -1) {
					toggler.setAttribute('aria-expanded', false);
				}
			}
		} else {
			//console.warn('Panel with id: "' + id + '" not found.');
		}
	};

	// function to handle clicks on a button INSIDE the panel, to close that panel
	var closePanel = function (closer) {
		// find parent panel and hide it
		var panel = closer.closest('[data-panel]');
		if (panel.getAttribute('aria-hidden') !== 'true') {
			panel.setAttribute('aria-hidden', true);
		}

		// if modal, send event for show or hide
		var isModal = panel.getAttribute('data-panel');
		if (isModal === 'Modal') {
			var event = new CustomEvent('modal:hide', { detail: panel });
			document.dispatchEvent(event);
		}

		setTogglerState(panel.id, false);
	};

	// set aria-expanded on the toggler button to animate icon
	var setTogglerState = function (panelId, expanded) {
		var toggler = document.querySelector('[aria-controls="' + panelId + '"]');
		if (toggler && toggler.className.indexOf('Button--toggler') !== -1) {
			// set state of toggler icon
			toggler.setAttribute('aria-expanded', expanded);
		}
	};

	// listen for any click to propagate up to document
	// then determine if and which panels should close
	var clickOutsideToClose = function (e) {
		var target = e.target;
		// make sure target is isn't a toggler or in a toggler
		if (!target.hasAttribute('aria-controls') && !target.closest('[aria-controls]')) {
			// is the click target not a panel itself and not inside a panel?
			if (!target.hasAttribute('data-panel') && !target.closest('[data-panel]')) {
				// is it not a modal background that should not close a modal?
				if (!target.hasAttribute('data-modal-prevent-clickoutside')) {
					// close other open panels if appropriate
					Array.prototype.forEach.call(panels, function (otherPanel) {
						// there are a few ways to label panels to make them stay open
						// for backwards compatibility, let's handle them all
						var panelAttribute = otherPanel.getAttribute('data-panel');
						var stayOpen = otherPanel.getAttribute('data-panel-stayopen');
						// is it visible?
						if (otherPanel.getAttribute('aria-hidden') !== 'true') {
							// is it closeable?
							if (!stayOpen && stayOpenValues.indexOf(panelAttribute) === -1) {
								// should it remain open based on breakpoint?
								switch (panelAttribute) {
									case 'hiddenForSmall':
										if (window.innerWidth < breakpointMedium) {
											otherPanel.setAttribute('aria-hidden', true);
											setTogglerState(otherPanel.id, false);
										}
										break;
									case 'hiddenForMedium':
										if (window.innerWidth >= breakpointMedium) {
											otherPanel.setAttribute('aria-hidden', true);
											setTogglerState(otherPanel.id, false);
										}
										break;
									default:
										otherPanel.setAttribute('aria-hidden', true);
										setTogglerState(otherPanel.id, false);
										break;
								}
								// send modal hide event if click on modal background
								if (panelAttribute === 'Modal' && target.hasAttribute('data-modal-background')) {
									var event = new CustomEvent('modal:hide', { detail: otherPanel });
									document.dispatchEvent(event);
								}
							}
						}
					});
				}
			}
		}
	};

	var setPanelVisibility = function () {
		// only respond to changes in width, not height
		var viewportWidth = window.innerWidth;
		if (lastViewportWidth !== viewportWidth) {
			lastViewportWidth = viewportWidth;
			Array.prototype.forEach.call(panels, function (panel) {
				var initialState = panel.getAttribute('data-panel');
				switch (initialState) {
					case 'hiddenForSmall':
						if (viewportWidth >= breakpointMedium) {
							panel.setAttribute('aria-hidden', false);
							setTogglerState(panel.id, true);
						} else {
							panel.setAttribute('aria-hidden', true);
							setTogglerState(panel.id, false);
						}
						break;
					case 'hiddenForMedium':
						if (viewportWidth >= breakpointMedium) {
							panel.setAttribute('aria-hidden', true);
							setTogglerState(panel.id, false);
						} else {
							panel.setAttribute('aria-hidden', false);
							setTogglerState(panel.id, true);
						}
						break;
				}
			});
		}
	};

	// listen for clicks to propagate up to document
	// determine if they've clicked a toggler, a closer, or neither
	document.addEventListener('click', function (e) {
		var toggler = e.target.closest('[aria-controls]');
		if (toggler) {
			e.preventDefault();
			togglePanel(toggler);
		} else {
			var closer = e.target.closest('[data-close]');
			if (closer) {
				e.preventDefault();
				closePanel(closer);
			} else {
				clickOutsideToClose(e);
			}
		}
	});

	setPanelVisibility();

	document.addEventListener('lichen:resize', setPanelVisibility);

	// Element.closest() polyfill for IE
	// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
	if (!Element.prototype.matches) {
		Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}
	if (!Element.prototype.closest) {
		Element.prototype.closest = function (s) {
			var el = this;
			do {
				if (Element.prototype.matches.call(el, s)) {
					return el;
				}
				el = el.parentElement || el.parentNode;
			} while (el !== null && el.nodeType === 1);
			return null;
		};
	}
};

document.addEventListener('lichen:loaded', initializeTogglePanel);
